import styled from 'styled-components';

import { VFlex } from '@/components/base';

const CardContainer = styled(VFlex)`
  background-color: ${(props) => props.theme.colors.gray100};
  border: 1px solid ${(props) => props.theme.colors.gray300};
  border-radius: ${(props) => props.theme.radius.card}px;
  padding: 16px 24px 20px;
`;

export default CardContainer;
